import { useEffect } from 'react';
import useSearchMutation from 'app/adapters/shared/ReactQueryReduxAdapter/useSearchMutation';

export default () => {
  const searchMutation = useSearchMutation();

  useEffect(() => {
    window.addEventListener('popstate', () => {
      const url = decodeURI(
        document.location.pathname + document.location.search
      );
      searchMutation.mutateAsync({ searchPath: url, pushState: false });
    });
  }, []);
};
